import React, { FC, useContext, useEffect, useState } from 'react'

import { clsx } from 'clsx'
import { useMediaQuery } from 'react-responsive'

import ICONS from 'Components/PaymentIcon/components/Icons'

import { Context } from './Context'
import { SprNumberFormat } from './types'

interface Props {
  className?: string
  format?: SprNumberFormat
  handleValid?: () => void
  iconClass?: string
  label?: string
  placeholder?: string
  style?: string
  wrapperClass?: string
}

export const NumberInput: FC<Props> = ({
  className,
  wrapperClass,
  iconClass,
  format = 'plainFormat',
  label = 'Credit number',
  placeholder = 'Card number',
  style = '',
  handleValid,
}) => {
  const [cardType, setCardType] = useState('')
  const screenMDMin = useMediaQuery({ query: `(min-device-width: 992px)` })

  const { formId, onField, setFieldType, setLabel, setPlaceholder, setStyle, setNumberFormat } = useContext(Context)
  useEffect(
    () =>
      onField('number', (type, _, inputProperties) => {
        if (type === 'input') {
          if (inputProperties.validNumber) handleValid?.()
          setCardType(inputProperties.cardType)
        }
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onField],
  )

  useEffect(() => setFieldType('number', screenMDMin ? 'text' : 'number'), [screenMDMin, setFieldType])

  useEffect(() => {
    setNumberFormat(format)
  }, [format, setNumberFormat])

  useEffect(() => {
    setLabel('number', label)
  }, [label, setLabel])

  useEffect(() => {
    setPlaceholder('number', placeholder)
  }, [placeholder, setPlaceholder])

  useEffect(() => {
    setStyle('number', style)
  }, [style, setStyle])

  const PaymentIcon = ICONS[cardType]

  return (
    <div className={clsx(wrapperClass, { 'has-icon': PaymentIcon })}>
      {PaymentIcon ? <PaymentIcon className={iconClass} type={cardType} /> : null}
      <div className={className} id={`${formId}-spr-number`} />
    </div>
  )
}
